export default class {
    constructor(obj = {}) {
        this.id = obj.id
        this.type = obj.type
    }
}



// WEBPACK FOOTER //
// ./src/sites/dto/HoverDto.js